/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Referral Agent DTO
 */
export interface ReferralAgentDto {
  id?: number;
  name?: string;
  commissionRate?: number;
  /**
   * Linked accounts count
   */
  linkedAccountsCount: number;
}
